import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { useMemo as D, useRef as d, useState as g } from "react";
import k from "debounce-promise";
var x = function x(_ref) {
  var e = _ref.form,
    b = _ref.name,
    y = _ref.debounceDelay,
    t = _ref.formatResults;
  var p, u;
  var n = (p = e == null ? void 0 : e.formSchema) == null ? void 0 : p[b],
    _g = g(!1),
    _g2 = _slicedToArray(_g, 2),
    a = _g2[0],
    i = _g2[1],
    _g3 = g(((u = n == null ? void 0 : n.options) == null ? void 0 : u.defaultLocationOptions) || []),
    _g4 = _slicedToArray(_g3, 2),
    c = _g4[0],
    L = _g4[1],
    O = d(k( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(s) {
        var o;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              o = n == null ? void 0 : n.options;
              if (!(o != null && o.searchPlace)) {
                _context.next = 6;
                break;
              }
              i(!0);
              _context.next = 5;
              return o.searchPlace(s).then(function (l) {
                i(!1);
                var P = (t == null ? void 0 : t(l)) || l;
                L(P);
              });
            case 5:
              return _context.abrupt("return", _context.sent);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), y, {
      leading: !1
    })),
    r = d(function (s) {
      return O.current(s);
    });
  return D(function () {
    return {
      options: c,
      isLoading: a,
      loadOptions: r
    };
  }, [c, a, r]);
};
export { x as useLocationData };